require('./bootstrap');
require('./common');

require('admin-lte/plugins/datatables/jquery.dataTables.min.js');
require('admin-lte/plugins/datatables-bs4/js/dataTables.bootstrap4.min.js');
require('admin-lte/plugins/datatables-responsive/js/dataTables.responsive.min.js');
require('admin-lte/plugins/datatables-responsive/js/responsive.bootstrap4.min.js');
require('admin-lte/plugins/select2/js/select2.full.min.js');
require('admin-lte/plugins/jquery-validation/jquery.validate.min.js');
require('admin-lte/plugins/jquery-validation/additional-methods.min.js');
require('admin-lte/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.js');
require('admin-lte/plugins/inputmask/jquery.inputmask.min.js');
require('tinymce');
require('tinymce/plugins/autolink');
require('tinymce/plugins/link');
require('magnific-popup/dist/jquery.magnific-popup.min.js');

window.lodash = require('lodash');
window.bsCustomFileInput = require('admin-lte/plugins/bs-custom-file-input/bs-custom-file-input.min.js');

$(function(){
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        complete: function(jqXHR, textStatus){
            if(jqXHR.status == "401"){
                var url = location.href;
                if(url.includes("secretary")){
                    location.href = "/secretary"
                }else if(url.includes("admin")){
                    location.href = "/admin"
                }else if(url.includes("school")){
                    location.href = "/school"
                }else{
                    location.href = "/"
                }
            }else if(jqXHR.status != "200"){
                alert("エラーが発生しました。システム管理者に連絡してください。");
            }else{
            }
        }
    });

    // 全角カタカナのみ
    $.validator.addMethod("furigana", function(value, element) {
        return this.optional(element) || /^([ぁ-ん 　ー（）]+)$/.test(value);
    }, "全角ひらがなを入力してください。");

    // 郵便番号
    jQuery.validator.addMethod("postal", function(value, element) {
        return this.optional(element) || /^\d{3}\-\d{4}$/.test(value)  || /^\d{7}$/.test(value);
        }, "郵便番号は、フォーマットと一致しません。（例:123-4567）"
    );

    // 電話番号
    jQuery.validator.addMethod("telephone", function(value, element) {
        //return this.optional(element) || /^\d{2}-\d{4}-\d{4}$/.test(value) || /^\d{3}-\d{3}-\d{4}$/.test(value) || /^\d{3}-\d{4}-\d{4}$/.test(value) || /^\d{10}$/.test(value)|| /^\d{11}$/.test(value);
        return this.optional(element) || ((/^\d{10}$/.test(value.replace(/-/g,""))|| /^\d{11}$/.test(value.replace(/-/g,""))) && /^([0-9-]+)$/.test(value))
        }, "電話番号は、フォーマットと一致しません。"
    );

    // FAX番号
    jQuery.validator.addMethod("fax", function(value, element) {
        //return this.optional(element) || /^\d{2}-\d{4}-\d{4}$/.test(value) || /^\d{3}-\d{3}-\d{4}$/.test(value) || /^\d{10}$/.test(value);
        return this.optional(element) || ((/^\d{10}$/.test(value.replace(/-/g,""))|| /^\d{11}$/.test(value.replace(/-/g,""))) && /^([0-9-]+)$/.test(value))
        }, "FAX番号は、フォーマットと一致しません。"
    );

    jQuery.validator.addMethod("date_group", function(value, element) {
            return this.optional(element) || ($(element).closest("dt").find("input:not([type=hidden]):eq(2)").val() >= $(element).closest("dt").find("input:not([type=hidden]):eq(1)").val());
            //return  $(element).closest("dt").find("input").map(function(i,obj){return $(obj).val();}).get().every(function(v){ return v; });
        }, "FROMはTO以上でなければなりません。"
    );

    jQuery.validator.addMethod("required_file", function(value, element) {
        return value.trim() != "";
        }, ":attributeをアップロードください。"
    );

    jQuery.validator.addMethod("birth_date", function(value, element) {
        $e = $(element).parent().find("select");
        var date = '';
        $e.each((k,v) => date = date + $(v).find(':selected').val());
        return moment(date, 'YYYYMMDD', true).isValid();
        }, ":attributeは有効な日付ではありません。"
    );

    jQuery.validator.addMethod("in", function(value, element, options) {
            var arr = [];

            if (options && (typeof options === 'string' || options instanceof String) && options.length > 0) {
                arr = options.split(",");
            } else if (Array.isArray(options) && (options.length > 0)) {
                arr = options;
            }

            if (arr.length > 0) {
                return !(value === undefined || value === null || value === '') && arr.includes(value);
            } else {
                return true;
            }
        }, ":attributeは無効です。"
    );

    jQuery.validator.addMethod("pilot_cer_number", function (value, element) {
            return this.optional(element) || /^\d{5}$/.test(value);
        }, "水中ドローン安全潜航操縦士認定番号は、フォーマットと一致しません。（例:12345）"
    );

    jQuery.validator.addMethod("instructor_cer_number", function (value, element) {
            return this.optional(element) || /^INS\d{3}$/.test(value);
        }, "水中ドローンインストラクター認定番号は、フォーマットと一致しません。（例:INS123）"
    );

    jQuery.validator.addMethod('accept', function () { return true; });

    $.validator.setDefaults({
        // errorPlacement: function(error, element) {
        //     console.log(error);
        //     console.log(element);
        //     var $form = element.closest("form");
        //     var $wrapper = element.closest("form").find('ul.alert');
        //     var $content = $("<ul class='alert alert-danger'></ul>");
        //     if($wrapper.length == 0){
        //         $content.prependTo($form);
        //     }
        //     error.appendTo($content);
        //     console.log("xong");
        // },
        onfocusout: false,
        onclick:false,
        errorLabelContainer: "#form-errors",
        errorElement: "li",
        invalidHandler: function(event, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
                $(".server-errors").remove();
                $("#form-errors").addClass("alert alert-danger");
                if ($("body").find("#form-errors li.error:first").length != 0){
                    $('html, body').animate({
                        scrollTop: $("body").find("#form-errors li.error:first").offset().top - 150
                    }, 500);
                }
            } else {
                $("#form-errors").removeClass("alert alert-danger");
            }
        },
        highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid');
        },
        showErrors: function (errorMap, errorList) {

            this.errorList = $.grep(errorList, function (error) {
                return error.element !== undefined;
            });
            this.defaultShowErrors();
            var found = {};
            $('ul#form-errors li').each(function(){
                var $this = $(this);
                if(found[$this.attr('id')]){
                    $this.remove();
                }else{
                    found[$this.attr('id')] = true;
                }
            });
        },
        submitHandler: function (form) {
            // Prevent double submission
            if (!this.beenSubmitted) {
                this.beenSubmitted = true;
                form.submit();
            }
        }
        // errorPlacement: function(error, element) {
        //     console.log(error);
        //     console.log(element);
        //     if(element.parent('.input-group').length) {
        //         error.insertAfter(element.parent());
        //     }else if(element.parent('.custom-file').length) {
        //         error.insertAfter(element.parent().parent());
        //     } else if (element.hasClass("summernote")) {
        //         error.insertAfter(element.siblings(".note-editor"));
        //     } else if (element.hasClass("select2")) {
        //         error.insertAfter(element.siblings(".select2-container"));
        //     } else {
        //         error.insertAfter(element);
        //     }
        // }
    });

    $(document).on("click",".btn_reset",function(){
        $(this).closest("form")[0].reset();
        $(this).closest("form").find("input[type=text]").val("");
        $(this).closest("form").find("input").prop("checked",false);
        $(this).closest("form").find("select").val("0","selected");
        $(this).closest("form").find("select.select2").val([]).trigger('change');
    });

    $(document).on("click",".btn_back",function(){
        window.history.back();
    });

    $(document).on("change",".photo-preview-dropzone input[type=file]",function(){
        //var fileName = $(this).val().replace(/.*(\/|\\)/, '');
        if (this.files && (this.files.length > 0)) {
            var file = this.files[0];

            var imgLocal = $(this).closest(".photo-preview-dropzone").find("img.photo-preview-dropzone-img-local");

            if (imgLocal) {
                imgLocal.attr("src", URL.createObjectURL(file));
                imgLocal.removeClass("d-none");
            }

            var imgRemote = $(this).closest(".photo-preview-dropzone").find("img.photo-preview-dropzone-img-remote");

            if (imgRemote) {
                imgRemote.addClass("d-none");
            }

            var placeHolder = $(this).closest(".photo-preview-dropzone").find(".photo-preview-dropzone-placeholder");

            if (placeHolder) {
                placeHolder.addClass("d-none");
            }
        } else {
            var imgLocal = $(this).closest(".photo-preview-dropzone").find("img.photo-preview-dropzone-img-local");

            if (imgLocal) {
                imgLocal.attr("src", "");
                imgLocal.addClass("d-none");
            }

            var imgRemote = $(this).closest(".photo-preview-dropzone").find("img.photo-preview-dropzone-img-remote");
            var placeHolder = $(this).closest(".photo-preview-dropzone").find(".photo-preview-dropzone-placeholder");

            if (imgRemote && imgRemote.attr("src")) {
                imgRemote.removeClass("d-none");

                if (placeHolder) {
                    placeHolder.addClass("d-none");
                }
            } else {
                if (placeHolder) {
                    placeHolder.removeClass("d-none");
                }
            }
        }
    });

    $.extend( $.fn.dataTable.defaults, {
        searching: false,
        info: false,
        autoWidth: false,
        responsive: true,
        lengthChange: false,
        processing: true,
        serverSide: true,
        stateSave: false,
        order: [0,'desc'],
        language: {
            paginate: {
                first:    '«',
                previous: '‹',
                next:     '›',
                last:     '»'
            }
        },
        drawCallback: function(settings) {
            var pagination = $(this).closest('.dataTables_wrapper').find('.dataTables_paginate');
            pagination.toggle(this.api().page.info().pages > 1);
        }
    });

    setTimeout(function(){
        // Datepicket Code
        $('.datetimepicker').datetimepicker({
            'format': 'YYYY/MM/DD',
            'locale': 'ja'
        });

        $('.timepicker').datetimepicker({
            'format': 'LT',
            'locale': 'ja'
        });

        //Datatable
        $(".data-table").DataTable({
            "responsive": true,
            "autoWidth": false,
        });

        // $(".post_code").inputmask({"mask": "999-9999"});

        // $(".amount").inputmask('Regex', { regex: "^[1-9][0-9]?$|^100$" });

        //Initialize Select2 Elements
        $('.select2').select2();

        //Initialize Select2 Elements
        $('.select2bs4').select2({
            theme: 'bootstrap4',
            width: '100%'
        });

        $("input[name*='postal_code']").attr("placeholder", "0000000");
        $("input[name*='address']").attr("placeholder", "○○県○○町○丁目○ー○");
        $("input[name*='address_extra']").attr("placeholder", "○○マンション○号室");
        $("input[name*='phone_number']").attr("placeholder", "000-0000-0000");
        $("input[name*='fax_number']").attr("placeholder", "000-0000-0000");
        $("input[name='billing_address']").attr("placeholder", ""); //except 'billing_address'
    },1);
});
